import React, {Component} from 'react';
import env from 'c-nenv';
import WechatShare from 'c-up-wechatshare';
import lang from '../lang/index';
import Title from 'c-title';

class ImageTypeView extends Component {
	static  defaultProps = {
		data: {}
	}

	componentWillMount(){
		let  { content, dynamicShareInfo} = this.props.data;

		if (dynamicShareInfo.title) {
            Title.set(dynamicShareInfo.title);
        }
        
		if (env.platform.isWeixin) {
            let wechatShare = new WechatShare();

            wechatShare.set({
                title: dynamicShareInfo.title,
                link: dynamicShareInfo.shareUrl,
                imgUrl: content.coverUrl,
                desc: dynamicShareInfo.desc
            });
        }
	}
    render() {
    	let content = this.props.data.content;

        return (
            <div className="content-wrapper image-wrapper">
                <i className="type">{lang.template('图片')}</i>
                { 
                    content.resourceUrls.map((item, index)=>{
                        return <img key={index} src={item}/>;
                    })
                }
                <div className="btns">
                    <div className="btn" onClick={()=> $.channel.emit('download')}>{ lang.template('打开Up直播，直播全世界') }</div>
                </div>
            </div>
        );
    }
}

export default ImageTypeView;



// WEBPACK FOOTER //
// ./js/feedshare/image.js